(function () {

    "use strict";

    // Location (Html5Mode)
    function logConfiguration($logProvider) {
        $logProvider.debugEnabled(false);
    }

    logConfiguration.$inject = ["$logProvider"];


    // Location (Html5Mode)
    function locationConfiguration($locationProvider) {
        $locationProvider.html5Mode(false);
    }

    locationConfiguration.$inject = ["$locationProvider"];

    // Routing
    function routingConfiguration($stateProvider) {
        $stateProvider.state("home", {
            url: "/aplica",
            template: "<sphforms-home></sphforms-home>"
        });
    }

    routingConfiguration.$inject = ["$stateProvider"];

    // Exceptions
    function exceptionConfig($provide) {
        $provide.decorator("$exceptionHandler", extendExceptionHandler);
    }

    exceptionConfig.$inject = ["$provide"];

    function extendExceptionHandler($delegate) {
        return function (exception, cause) {
            $delegate(exception, cause);
        };
    }

    extendExceptionHandler.$inject = ["$delegate"];

    angular.module("sphforms.app")
        .config(locationConfiguration)
        .config(logConfiguration)
        .config(routingConfiguration)
        .config(exceptionConfig);
}());
